import { isMine, DEFAULT_MINE_PROBABILITY } from '../core/mineGenerator';

// 8 neighbor offsets (NW, N, NE, W, E, SW, S, SE)
const OFFSETS = [
  [-1, -1], [0, -1], [1, -1],
  [-1,  0],          [1,  0],
  [-1,  1], [0,  1], [1,  1],
];

/**
 * Calculates the number of mines in the 8 surrounding cells of (x, y).
 * Works across 10x10 box boundaries and negative coordinates seamlessly.
 */
export function getAdjacentMineCount(
  seed: string,
  x: number,
  y: number,
  mineProbability: number = DEFAULT_MINE_PROBABILITY
): number {
  let count = 0;
  for (let i = 0; i < OFFSETS.length; i++) {
    const nx = x + OFFSETS[i][0];
    const ny = y + OFFSETS[i][1];
    if (isMine(seed, nx, ny, mineProbability)) {
      count++;
    }
  }
  return count;
}
